export default {
  list: {
    title: "Drivers",
    newDriver: "New driver",
    scope: { recruiter: "My drivers", branch_manager: "Branch drivers", owner: "All drivers" },
    filters: { stageMonth: "Stage in month", stageAdded: "Added", month: "Month",
      driverType: "Driver type",
      freight: "Freight",
      source: "Source",
      state: "State",
      cdlClass: "CDL class",
      classN: "Class {{cls}}",
      dateAdded: "Date added",
      recruiter: "Recruiter",
      allRecruiters: "All recruiters",
      legalStatus: "Legal status",
      problem: "Problem",
    },
    dateAdded: {
      today: "Today",
      d7: "Last 7 days",
      d30: "Last 30 days",
      d90: "Last 90 days",
      d180: "Last 180 days",
      y1: "Last 1 year",
      older90d: "Older than 90 days",
      older180d: "Older than 180 days",
      older1y: "Older than 1 year",
      custom: "Custom range (From – To)…",
      from: "From",
      to: "To",
    },
    problem: { any: "Any problem", incomplete: "Profile incomplete", docs_missing: "Required documents missing", docs_expiring: "Documents expiring soon", docs_expired: "Documents expired", overdue_reminder: "Overdue reminder", no_contact: "No contact for a while", stale: "Stuck in stage", unassigned: "No recruiter" },
    search: "Search:",
    chips: { all: "All", lost: "Lost" },
    empty: {
      filteredTitle: "No drivers match these filters",
      filteredHint: "Try clearing a filter or searching by phone.",
      title: "No drivers yet",
      hint: "Add your first driver or import the Google Sheets.",
    },
    selectAll: "Select all",
    selectOne: "Select {{name}}",
    cols: {
      carrier: "Carrier",
      name: "Name",
      phone: "Phone",
      state: "State",
      cdl: "CDL / exp.",
      status: "Status",
      source: "Source",
      owner: "Owner",
      lastContact: "Last contact",
      nextAction: "Next action",
    },
    pool: "Pool",
    pagLabel: "drivers",
    next: {
      reason: "Reason: {{reason}}",
      firstCall: "First call",
      waitingCarrier: "Waiting for carrier",
      overdueToday: "{{label}} · overdue today",
      overdueDays_one: "{{label}} · overdue {{count}} day",
      overdueDays_other: "{{label}} · overdue {{count}} days",
    },
  },
  statusModal: {
    title: "Change status",
    now: "{{name}} · now {{status}}",
    newStatus: "New status",
    select: "Select…",
    pipeline: "Pipeline",
    lost: "Lost",
    current: "(current)",
    job: "Job / carrier",
    jobHint: "Only open jobs are listed.",
    docsMissing: "Documents not in yet: {{names}}.",
    docsBlocked: "Submitting is blocked until they are uploaded (Settings → Documents).",
    loading: "Loading…",
    startDate: "Start date",
    reason: "Reason",
    note: "Note",
    notePlaceholderHired: "Evidence: carrier confirmed by email, orientation done…",
    optional: "Optional",
    hiredNote: "Hired is counted after manager approval (Approvals).",
    submittedNote: "An application is created for the chosen job and recorded in the driver's history.",
    errors: {
      chooseStatus: "Choose a status.",
      jobRequired: "Job / carrier is required.",
      chooseJob: "Choose a job (carrier).",
      startDate: "Start date is required.",
      reason: "Reason is required.",
    },
    updated: "Status updated",
    changedBy: "Changed by {{who}}. Reloaded.",
    someoneElse: "someone else",
    reloadedHint: "Review the current state and try again.",
    failed: "Could not change the status",
  },
  form: {
    contact: "Contact",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    noPhoneWarning: "No phone yet — calls and duplicate checks will not work until it is added.",
    driverType: "Driver type",
    freight: "Freight",
    phoneHint: "Any format, e.g. (555) 010-0142",
    email: "Email",
    state: "State",
    select: "Select…",
    city: "City",
    secondaryPhone: "Secondary phone",
    legalStatus: "Legal status",
    dob: "Date of birth",
    dobHint: "Shown masked to recruiters",
    cdlMedical: "CDL & medical",
    cdlClass: "CDL class",
    cdlState: "CDL state",
    cdlNumber: "CDL number",
    cdlNumberHint: "Also checked for duplicates",
    cdlNumberPlaceholder: "e.g. 12345678",
    managedByManager: "Managed by your manager",
    cdlExpires: "CDL expires",
    medicalExpires: "Medical card expires",
    endorsements: "Endorsements",
    experienceTitle: "Experience & preferences",
    experience: "Experience",
    years: "years",
    months: "months",
    drivingType: "Driving type",
    equipment: "Equipment",
    homeTime: "Home time",
    desiredPay: "Desired pay",
    desiredPayPlaceholder: "$1,400 / week",
    availableFrom: "Available from",
    sourceTitle: "Source",
    source: "Source",
    referredBy: "Referred by",
    referredByPlaceholder: "Only for Referral",
    owner: "Owner",
    ownerHint: "Empty = branch pool, the manager assigns it",
    pool: "Branch pool (unassigned)",
    notes: "Notes",
    notesPlaceholder: "First call notes, preferences...",
    validation: {
      required: "Required",
      phone: "Enter a valid phone number",
      email: "Enter a valid email",
      years: "0–40",
      months: "0–11",
      duplicate: "Already in database",
    },
  },
  dup: {
    phoneSecondary: "Second phone",
    email: "Email",
    sameName_one: "{{count}} driver with the same name is already in the database:",
    sameName_other: "{{count}} drivers with the same name are already in the database:",
    scamShort: "⚠ SCAM since {{date}}",
    confirm: "This is a different person — add anyway",
    scam: "⚠ SCAM: this driver was marked as a scam on {{date}}.",
    scamBy: "Marked by {{name}}",
    lost: "{{status}} on {{date}} · reason: {{reason}}.",
    reopenHint: "Open the profile and reopen it as {{a}} or {{b}} — the history stays.",
    title: "Possible duplicate.",
    phone: "Phone {{phone}}",
    cdl: "CDL number",
    belongsTo: "belongs to",
    owner: "owner {{name}}",
    unassigned: "unassigned (pool)",
    assignedUntil: "assigned until {{date}}",
    open: "Open profile",
    askTransfer: "Ask manager to transfer",
  },
  new: {
    breadcrumb: "Drivers",
    title: "New driver",
    added: "Driver added",
    addedDesc: "{{name}} is now in New.",
    checkFields: "Check the highlighted fields",
    saveFailed: "Could not save the driver",
    transferNote: "Duplicate found while adding a driver",
    requestSent: "Request sent to your manager",
    requestSentDesc: "You will be notified when it is decided.",
    requestFailed: "Could not send the request",
    you: "you",
    selectedRecruiter: "selected recruiter",
    pool: "the branch pool (unassigned)",
    ownerAfter: "After saving, the owner is",
    assignedFor: "assigned for {{days}} days (until {{until}})",
    required: "required",
    save: "Save driver",
  },
  profile: {
    noPhone: "No phone",
    tabs: {
      overview: "Overview",
      applications: "Applications ({{n}})",
      activity: "Activity ({{n}})",
      documents: "Documents {{n}}/{{total}}",
      history: "History",
    },
    approvedBy: "approved by {{name}}",
    manager: "manager",
    pendingApproval: "pending manager approval",
    source: "Source: {{source}}",
    owner: "Owner:",
    pool: "branch pool (unassigned)",
    assignedUntil: "assigned until {{date}}",
    added: "added {{date}}",
    submitToJob: "Submit to job",
    logCall: "Log call",
    changeStatus: "Change status",
    hero: { call: "Call", note: "Note", moveTo: "Move to {{stage}}", more: "More actions" },
    nextStep: { title: "Next step", overdue: "overdue", markDone: "Mark done", none: "No next step yet. Add a reminder so the driver is not forgotten." },
    stageBar: { label: "Stage", hint: "Drag the handle or click a stage to move the driver", notAllowed: "Not available from this stage", saving: "Saving…" },
    daysInStage_one: "{{count}} day in this stage",
    daysInStage_other: "{{count}} days in this stage",
    applications: "Applications ({{n}})",
    details: {
      phone: "Phone",
      email: "Email",
      owner: "Owner",
      added: "Added",
      driverType: "Driver type",
      freight: "Freight",
      title: "Driver details",
      fullName: "Full name",
      dob: "Date of birth",
      cdl: "CDL",
      classN: "Class {{cls}}",
      hideCdl: "Hide CDL number",
      showCdl: "Show CDL number",
      cdlExpires: "CDL expires",
      medicalExpires: "Medical card expires",
      expired: "⚠ expired {{days}} days ago",
      expiresIn: "⚠ in {{days}} days",
      experience: "Experience",
      year_one: "{{count}} year",
      year_other: "{{count}} years",
      endorsements: "Endorsements",
      equipment: "Equipment",
      preferences: "Preferences",
      home: "Home {{value}}",
      availableFrom: "Available from",
      secondaryPhone: "Secondary phone",
      legalStatus: "Legal status",
      referredBy: "Referred by",
      notes: "Notes",
      importedFrom: "Imported from",
    },
    retention: {
      title: "Retention",
      subtitle: "{{job}} · {{carrier}} · start {{date}}",
      confirmedChip: "{{days}} days · {{date}}",
      confirmed: "{{days}}-day retention confirmed",
      confirm: "Confirm {{days}} days",
      due: "due {{date}}",
      dueTitle: "Due {{date}}",
    },
    apps: {
      payment: "Payment",
      empty: "No applications yet. Submit the driver to a job.",
      job: "Job",
      carrier: "Carrier",
      status: "Status",
      date: "Date",
      submitted: "Submitted",
      by: "By",
      reply: "Carrier reply",
      decided: "Decided",
      rejected: "Rejected · {{reason}}",
      start: "start {{date}}",
    },
    activity: {
      title: "Activity",
      addReminder: "Add reminder",
      type: "Activity type",
      types: { note: "Note", call: "Call", sms: "SMS", email: "Email", status: "Status", system: "System" },
      system: "System",
      created: "Created",
      callMins: "Call, {{mins}} min",
      min: "min",
      duration: "Duration, minutes",
      outcome: "Outcome",
      outcomes: { answered: "Answered", no_answer: "No answer", voicemail: "Voicemail", busy: "Busy" },
      placeholderCall: "How did the call go?",
      placeholderNote: "Add a note or log a call...",
      callLogged: "Call logged",
      nextReminder: "Next reminder:",
      overdue: "overdue",
      tomorrow: "Tomorrow",
      reminderDone: "Reminder done",
      noPending: "No pending reminders.",
      loading: "Loading activity…",
      empty: "No activity yet.",
      emptyTitle: "No activity yet",
      showAll: "Show all activity ({{n}}) →",
      page: "Page {{page}} of {{pages}}",
    },
    reminder: {
      title: "Add reminder",
      chooseDateTime: "Choose date and time.",
      added: "Reminder added",
      failed: "Could not add the reminder",
      type: "Type",
      date: "Date",
      time: "Time",
      timeHint: "Driver's time ({{tz}})",
      assignTo: "Assign to",
      driversOwner: "Driver's owner",
      note: "Note",
      notePlaceholder: "Confirm experience details",
    },
    history: { when: "When", change: "Change", reason: "Reason / note", job: "Job", by: "By" },
    edit: {
      title: "Edit {{name}}",
      desc: "Changes are written to the audit log.",
      updated: "Driver updated",
      conflictDesc: "Your edits were not saved. Check the new values and try again.",
      checkFields: "Check the highlighted fields",
    },
  },
};
